//OFFLINE_STORE
export const ALL_OFFLINE_STORE_REQUEST = "ALL_OFFLINE_STORE_REQUEST";
export const ALL_OFFLINE_STORE_SUCCESS = "ALL_OFFLINE_STORE_SUCCESS";
export const ALL_OFFLINE_STORE_FAIL = "ALL_OFFLINE_STORE_FAIL";

export const ALL_OFFLINE_STORE_COMPANY_REQUEST = "ALL_OFFLINE_STORE_COMPANY_REQUEST";
export const ALL_OFFLINE_STORE_COMPANY_SUCCESS = "ALL_OFFLINE_STORE_COMPANY_SUCCESS";
export const ALL_OFFLINE_STORE_COMPANY_FAIL = "ALL_OFFLINE_STORE_COMPANY_FAIL";